// AURELIA BOUTIQUE — Theme JS
'use strict';

document.addEventListener('DOMContentLoaded', () => {

  // ── Sticky header: hide on scroll down, show on scroll up ──
  const header = document.getElementById('site-header');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      header.classList.toggle('scrolled', current > 8);

      if (current > lastScroll && current > 150) {
        header.classList.add('hide');
      } else {
        header.classList.remove('hide');
      }
      lastScroll = current;
    }, { passive: true });
  }

  // ── Mobile menu ──
  const mobileBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileBtn && mobileNav) {
    mobileBtn.addEventListener('click', () => mobileNav.classList.toggle('open'));
  }

  // ── Search overlay ──
  const searchBtn = document.getElementById('search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = searchOverlay?.querySelector('.search-overlay__close');
  if (searchBtn && searchOverlay) {
    searchBtn.addEventListener('click', () => { searchOverlay.classList.add('open'); searchOverlay.querySelector('input')?.focus(); });
    searchClose?.addEventListener('click', () => searchOverlay.classList.remove('open'));
    searchOverlay.addEventListener('click', e => { if (e.target === searchOverlay) searchOverlay.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') searchOverlay.classList.remove('open'); });
  }

  // ── Cart drawer ──
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBtn = document.getElementById('cart-btn');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');
  const cartBackdrop = cartDrawer?.querySelector('.cart-drawer__backdrop');

  const openCart = () => { cartDrawer?.classList.add('open'); refreshCart(); };
  const closeCart = () => cartDrawer?.classList.remove('open');

  cartBtn?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartBackdrop?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ── Cart refresh ──
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        const totalEl = document.getElementById('drawer-total');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        const itemsEl = document.getElementById('drawer-items');
        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p class="cart-drawer__empty">Košík je prázdný</p>';
        } else {
          itemsEl.innerHTML = cart.items.map(item => `
            <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #E2DBD1;position:relative;">
              <img src="${item.image}" style="width:70px;height:90px;object-fit:cover;" alt="${item.title}">
              <div style="flex:1">
                <p style="font-size:0.8rem;margin-bottom:4px;padding-right:20px;">${item.product_title}</p>
                ${item.variant_title !== 'Default Title' ? `<p style="font-size:0.72rem;color:#9C9790">${item.variant_title}</p>` : ''}
                <p style="font-size:0.82rem;margin-top:6px">${formatMoney(item.line_price)}</p>
              </div>
              <button class="drawer-remove-btn" data-key="${item.key}" aria-label="Odebrat" style="position:absolute;top:14px;right:0;background:none;border:none;cursor:pointer;color:#9C9790;font-size:16px;line-height:1;padding:4px;">&times;</button>
            </div>`).join('');
        }
      })
      .catch(console.error);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('cs-CZ', { style: 'currency', currency: 'CZK', minimumFractionDigits: 0 });
  }

  // ── Remove item from drawer cart ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('.drawer-remove-btn');
    if (!btn) return;
    const key = btn.dataset.key;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(r => r.json())
    .then(() => refreshCart())
    .catch(console.error);
  });

  // ── Add to cart (quick button on cards) ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('.p-card__quick');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.id;
    if (!id) return;
    btn.textContent = 'Přidávám…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => { btn.textContent = 'Přidáno ✓'; openCart(); setTimeout(() => { btn.textContent = '+ Přidat do košíku'; }, 2000); })
    .catch(() => { btn.textContent = 'Chyba'; });
  });

  // ── Add to cart (PDP form) ──
  const pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const fd = new FormData(pdpForm);
      const atcBtn = pdpForm.querySelector('.pdp__atc');
      atcBtn.textContent = 'Přidávám…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity')) || 1 })
      })
      .then(r => r.json())
      .then(() => { atcBtn.textContent = 'Přidáno ✓'; openCart(); setTimeout(() => { atcBtn.textContent = 'Přidat do košíku'; }, 2500); })
      .catch(() => { atcBtn.textContent = 'Chyba, zkuste znovu'; });
    });
  }

  // ── Quantity buttons ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const wrap = btn.closest('.qty-wrap');
    const input = wrap?.querySelector('.qty-input');
    if (!input) return;
    let v = parseInt(input.value) || 1;
    v += parseInt(btn.dataset.dir);
    if (v < 1) v = 1;
    input.value = v;
  });

  // ── PDP gallery ──
  document.addEventListener('click', e => {
    const thumb = e.target.closest('.pdp__thumb');
    if (!thumb) return;
    const idx = thumb.dataset.idx;
    document.querySelectorAll('.pdp__thumb').forEach(t => t.classList.toggle('active', t.dataset.idx === idx));
    document.querySelectorAll('.pdp__slide').forEach(s => s.classList.toggle('active', s.dataset.idx === idx));
  });

  // ── Variant selector ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('.opt-btn');
    if (!btn) return;
    const opt = btn.dataset.opt;
    document.querySelectorAll(`.opt-btn[data-opt="${opt}"]`).forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });

});